import { trackEvent } from "../../utils/trackAnalytics";
const LOAD_PREFERENCES = "preferences:LOAD_PREFERENCES";
const SET_DATE_ORDER = "preferences:SET_DATE_ORDER";
const SET_THOUSANDS_SEPARATOR = "preferences:SET_THOUSANDS_SEPARATOR";

const SET_SKIN = "preferences:SET_SKIN";
const SET_AUTO_BACKUP = "preferences:SET_AUTO_BACKUP";
const SET_AUTO_BACKUP_COPIES = "preferences:SET_AUTO_BACKUP_COPIES";
const SET_AUTO_BACKUP_LOCATION = "preferences:SET_AUTO_BACKUP_LOCATION";

const SET_AUTO_CHECK_UPDATES = "preferences:SET_AUTO_CHECK_UPDATES";
const SET_AUTO_DOWNLOAD_UPDATES = "preferences:SET_AUTO_DOWNLOAD_UPDATES";

const SET_GLOBAL_FONT_SIZE = `preferences:SET_GLOBAL_FONT_SIZE`;

const SET_AUTO_CLOSE_SCRIVENER = `preferences:SET_AUTO_CLOSE_SCRIVENER`;

export const actionTypes = {
  LOAD_PREFERENCES,
  SET_DATE_ORDER,
  SET_THOUSANDS_SEPARATOR,
  SET_SKIN,
  SET_AUTO_BACKUP,
  SET_AUTO_BACKUP_COPIES,
  SET_AUTO_BACKUP_LOCATION,
  SET_AUTO_CHECK_UPDATES,
  SET_AUTO_DOWNLOAD_UPDATES,
  SET_GLOBAL_FONT_SIZE,
  SET_AUTO_CLOSE_SCRIVENER
};

const loadPreferences = data => {
  if (data.skin) {
    trackEvent("loadPreferences", "skin", data.skin);
  }
  return {
    type: LOAD_PREFERENCES,
    data
  };
};

const setDateOrder = dateOrder => {
  return {
    type: SET_DATE_ORDER,
    dateOrder
  };
};

const setThousandsSeparator = separator => {
  return {
    type: SET_THOUSANDS_SEPARATOR,
    separator
  };
};

const setSkin = skin => {
  return {
    type: SET_SKIN,
    skin
  };
};

const setAutoBackup = autoBackupEnabled => {
  return {
    type: SET_AUTO_BACKUP,
    autoBackupEnabled
  };
};

const setAutoBackupLocation = autoBackupLocation => {
  return {
    type: SET_AUTO_BACKUP_LOCATION,
    autoBackupLocation
  };
};

const setAutoCheckUpdates = autoCheckUpdates => {
  return {
    type: SET_AUTO_CHECK_UPDATES,
    autoCheckUpdates
  };
};

const setAutoDownloadUpdates = autoDownloadUpdates => {
  return {
    type: SET_AUTO_DOWNLOAD_UPDATES,
    autoDownloadUpdates
  };
};

const setAutoCloseScrivener = autoCloseScrivener => {
  return {
    type: SET_AUTO_CLOSE_SCRIVENER,
    autoCloseScrivener
  };
};

const setGlobalFontSize = fontSize => {
  return {
    type: SET_GLOBAL_FONT_SIZE,
    fontSize
  };
};

export default {
  loadPreferences,
  setDateOrder,
  setThousandsSeparator,
  setSkin,
  setAutoBackup,
  setAutoBackupLocation,
  setAutoCheckUpdates,
  setAutoDownloadUpdates,
  setGlobalFontSize,
  setAutoCloseScrivener
};
